"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MedicationSearchItemSchema () {
        return MedicationSearchItemSchema;
    },
    get MedicationSearchRequestSchema () {
        return MedicationSearchRequestSchema;
    },
    get MedicationSearchResponseSchema () {
        return MedicationSearchResponseSchema;
    }
});
const _zod = require("zod");
const _medication = require("./medication");
const _prescriptionfrequency = require("./prescription-frequency");
const DELETE_CHARACTER = 0x7f;
const LAST_C0_CONTROL_CHARACTER = 0x1f;
/** True when the text holds no control character (U+0000 to U+001F, or U+007F). */ function hasNoControlCharacter(value) {
    for(let index = 0; index < value.length; index += 1){
        const unit = value.charCodeAt(index);
        if (unit <= LAST_C0_CONTROL_CHARACTER || unit === DELETE_CHARACTER) {
            return false;
        }
    }
    return true;
}
const MedicationSearchRequestSchema = _zod.z.object({
    q: _zod.z.string({
        message: 'Search text is required.'
    }).trim().min(2, {
        message: 'Enter at least 2 characters.'
    }).max(60, {
        message: 'Search text must be at most 60 characters.'
    }).refine(hasNoControlCharacter, {
        message: 'Search text must not contain control characters.'
    }),
    limit: _zod.z.number({
        message: 'Limit must be a number.'
    }).int({
        message: 'Limit must be a whole number.'
    }).min(1, {
        message: 'Limit must be between 1 and 20.'
    }).max(20, {
        message: 'Limit must be between 1 and 20.'
    }).default(10)
}).strict();
const MedicationSearchItemSchema = _zod.z.object({
    code: _medication.MedicationCodeSchema,
    genericName: _zod.z.string(),
    strength: _zod.z.string(),
    form: _medication.MedicationFormSchema,
    route: _zod.z.string(),
    therapeuticClass: _zod.z.string(),
    isDangerousDrug: _zod.z.boolean(),
    defaultFrequency: _prescriptionfrequency.PrescriptionFrequencySchema.nullable()
}).strict();
const MedicationSearchResponseSchema = _zod.z.object({
    items: _zod.z.array(MedicationSearchItemSchema)
}).strict();
